import Dict from '@/utils/dict-utils'

// 门户快捷键跳转到业务平台的操作页面
export const portalFeaturesRouter = new Dict({
  //  -------- 采购人功能 --------
  // 招标采购
  PURCHASER_BIDDING: {
    value: 'purchaser_bidding',
    router: 'BiddingList'
  },
  // 询比
  PURCHASER_INQUIRY: {
    value: 'purchaser_inquiry',
    router: 'InquiryList'
  },
  // 竞价
  PURCHASER_COMPETE: {
    value: 'purchaser_compete',
    router: 'CompeteManage'
  },

  // --------- 代理机构功能 ---------
  // 发布招标
  ENTRUST_BIDDING: {
    value: 'entrust_bidding',
    router: 'AgencyBiddingList'
  },
  // 发布询比
  ENTRUST_INQUIRY: {
    value: 'entrust_inquiry',
    router: 'AgencyEntrustInquiryList'
  },
  // 发布竞价
  ENTRUST_COMPETE: {
    value: 'entrust_compete',
    router: 'AgencyEntrustCompeteList'
  },

  // ---------- 供应商功能 ----------
  // 公告查询
  SUPPLIER_SEARCH: {
    value: 'supplier_search',
    router: 'PublicTenderList'
  },
  // 我参与的项目
  SUPPLIER_JOIN: {
    value: 'supplier_join',
    router: 'ParticipateBid'
  },
  // 受邀项目
  SUPPLIER_INVITE: {
    value: 'supplier_invite',
    router: 'InvitationLetter'
  }
})
